import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FFFDF5] flex items-center justify-center px-6" data-testid="not-found-page">
      <Helmet>
        <title>Page not found · HiBFF</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className="text-center max-w-md">
        <p className="text-7xl font-extrabold text-[#F59E0B] mb-4">404</p>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>
        <p className="text-sm text-gray-500 mb-8">
          The page you're looking for doesn't exist or may have moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#F59E0B] text-white text-sm font-semibold hover:bg-[#d97706] transition-colors"
          >
            <Home className="w-4 h-4" /> Go to homepage
          </Link>
          <button
            onClick={() => window.history.back()}
            data-testid="not-found-back-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Go back
          </button>
        </div>
      </div>
    </div>
  );
}
